import { type FlexProps, Flex, ErrorOutlineRoundedIcon, Text } from '@shared/components';

export interface SelectUsersCountBaseProps extends FlexProps {
  count?: number;
  maxCount?: number;
}

export function SelectUsersCount(props: Readonly<SelectUsersCountBaseProps>) {
  const { count = 0, maxCount = 0, ...restProps } = props;

  const isSelectOverMaxCount = count > maxCount;

  return (
    <Flex {...restProps}>
      <Text variant='h4' sx={{ mr: 'auto' }}>
        Select Member
      </Text>
      <Text
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
          color: isSelectOverMaxCount ? theme.palette.error.main : theme.palette.text.primary,
        })}
      >
        {isSelectOverMaxCount ? <ErrorOutlineRoundedIcon /> : null}
        {!isSelectOverMaxCount ? 'เลือกได้สูงสุด' : 'เกินจำนวนที่กำหนด'} {count}/{maxCount}
      </Text>
    </Flex>
  );
}
